// Stimulus controller for case selection dropdown with multi-select and 'All Cases' option
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["dropdownMenu", "option", "allCases"];

  connect() {
    this.selectedCases = new Set();
    this.syncAllCasesCheckbox();
    document.addEventListener('click', this.handleDocumentClickBound = this.handleDocumentClick.bind(this));
    // Add keyboard accessibility for checkboxes: toggle on Enter or Space
    document.addEventListener('keydown', this.handleCheckboxKeydownBound = this.handleCheckboxKeydown.bind(this));
  }

  disconnect() {
    document.removeEventListener('click', this.handleDocumentClickBound);
    document.removeEventListener('keydown', this.handleCheckboxKeydownBound);
  }

  toggleDropdown(event) {
    event.stopPropagation();
    this.dropdownMenuTarget.classList.toggle("hidden");
  }

  handleDocumentClick(event) {
    if (!this.element.contains(event.target)) {
      this.dropdownMenuTarget.classList.add("hidden");
    }
  }

  handleCheckboxKeydown(event) {
    if ((event.key === 'Enter' || event.key === ' ') && event.target.type === 'checkbox') {
      event.preventDefault();
      event.target.checked = !event.target.checked;
      // Fire change event so Stimulus logic runs
      const changeEvent = new Event('change', { bubbles: true });
      event.target.dispatchEvent(changeEvent);
    }
  }

  toggleCase(event) {
    const caseId = event.target.value;
    if (event.target.checked) {
      this.selectedCases.add(caseId);
    } else {
      this.selectedCases.delete(caseId);
    }
    this.syncAllCasesCheckbox();
  }

  toggleAllCases(event) {
    const checked = event.target.checked;
    this.optionTargets.forEach((el) => {
      el.checked = checked;
      if (checked) {
        this.selectedCases.add(el.value);
      } else {
        this.selectedCases.delete(el.value);
      }
    });
  }

  syncAllCasesCheckbox() {
    if (!this.hasAllCasesTarget) return;
    const allChecked = this.optionTargets.length > 0 && this.optionTargets.every((el) => el.checked);
    this.allCasesTarget.checked = allChecked;
  }
}
